import { get } from './apiService';
import type { Certification } from '../types/certification';

export async function getCertifications(): Promise<Certification[]> {
  return get<Certification[]>('/certification');
}
